<template>
    <div>
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="items"
            :sort-compare="sortCompare">
            <template #cell(amount)="row">
                <span>&euro; {{ formatAmount(row.item.amount) }}</span>
            </template>
            <template v-slot:cell(created_at)="row">
                <span>{{ row.item.created_at | date_time_om }}</span>
            </template>
            <template #cell(actions)="row">
                <b-button
                    class="btn-clean btn-inverse-primary"
                    :title="$t('user_account.order.details')"
                    @click="showModal(row.item)"
                    ><i class="fas fa-hand-pointer fa-fw"></i>
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <b-modal
            id="add-magazine-modal"
            v-if="selected != null"
            v-model="show_modal"
            ref="add-magazine-modal"
            modal-class="clean-modal account-order-overview-modal"
            :title="$t('user_account.order.order')"
            :ok-title="$t('common.close')"
            :cancel-title="$t('common.cancel')"
            cancel-variant="inverse-primary">
            <div class="order-modal">
                <design-2021-apprentice-data-table
                    :fields="orderFields"
                    :items="selected"
                    stacked
                    nosearch>
                    <template #cell(address)="row">
                        <span>{{ `${row.item.street} ${row.item.streetnumber}` }}</span>
                    </template>
                    <template #cell(amount)="row">
                        <span>&euro; {{ formatAmount(row.item.amount) }}</span>
                    </template>
                </design-2021-apprentice-data-table>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-account-orders-component',
    props: ['paymentsIn'],
    data() {
        return {
            selected: [],
            show_modal: false,
            tableColumns: ['title', 'amount', 'date', 'statusnl', 'actions'],
            fields: [
                {
                    key: 'title',
                    label: this.$t('common.title'),
                    sortable: true,
                },
                {
                    key: 'amount',
                    label: this.$t('user_account.order.amount'),
                    sortable: true,
                },
                {
                    key: 'created_at',
                    label: this.$t('user_account.order.date'),
                    sortable: true,
                },
                {
                    key: 'statusnl',
                    label: this.$t('user_account.order.status'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            items: [],
            orderFields: [
                {
                    key: 'address',
                    label: this.$t('user_account.order.address'),
                },
                {
                    key: 'zipcode',
                    label: this.$t('common.postal_code'),
                },
                {
                    key: 'city',
                    label: this.$t('common.city'),
                },
                {
                    key: 'quantity',
                    label: this.$t('user_account.order.quantity'),
                },
                {
                    key: 'amount',
                    label: this.$t('user_account.order.amount'),
                },
                {
                    key: 'statusnl',
                    label: this.$t('user_account.order.status'),
                },
            ],
            tableOptions: {
                headings: {
                    amount: this.$t('user_account.order.amount'),
                    date: this.$t('user_account.order.amount'),
                    title: this.$t('common.title'),
                    statusnl: this.$t('user_account.order.status'),
                    actions: this.$t('common.actions'),
                },
            },
        };
    },
    methods: {
        showModal(item) {
            this.show_modal = true;
            this.selected[0] = item;
        },

        formatAmount(amount) {
            return (amount / 100).toFixed(2);
        },

        sortCompare: function sortCompare(firstRow, secondRow, key) {
            if (key === 'created_at' && firstRow[key] && secondRow[key]) {
                var firstDate = moment(firstRow[key]).format('YYYY-MM-DD HH:mm:ss');
                var secondDate = moment(secondRow[key]).format('YYYY-MM-DD HH:mm:ss');
                return firstDate < secondDate ? -1 : firstDate > secondDate ? 1 : 0;
            } else {
                return false;
            }
        },
    },
    mounted() {
        if (this.paymentsIn) {
            this.items = this.paymentsIn.map((payment) => {
                return {
                    title: payment.paymentable.title,
                    ...payment,
                };
            });
        }
    },
};
</script>

<style scoped>
.accounts-order-overview >>> .table td,
.selected-payment-table >>> .table td {
    white-space: normal;
}

.selected-payment-table >>> .table tbody tr:hover {
    background-color: transparent !important;
}

.selected-payment-table >>> .apprentice-table-tools {
    display: none;
}

.selected-payment-table >>> .records-total {
    display: none;
}
</style>
